import { render, staticRenderFns } from "./px-numeric-input.vue?vue&type=template&id=72112dbd&scoped=true&"
import script from "./px-numeric-input.vue?vue&type=script&lang=ts&"
export * from "./px-numeric-input.vue?vue&type=script&lang=ts&"
import style0 from "./px-numeric-input.vue?vue&type=style&index=0&id=72112dbd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72112dbd",
  null
  
)

export default component.exports